import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GenericApiService } from './generic-api.service';

export interface SpaceContext {
  id: string;
  name: string;
  type: string;
  role: string;
  ancestors: string[];
}

@Injectable({
  providedIn: 'root'
})
export class SpaceContextService {
  private api = inject(GenericApiService);

  private availableContextsSubject = new BehaviorSubject<SpaceContext[]>([]);
  public availableContexts$ = this.availableContextsSubject.asObservable();

  private activeContextSubject = new BehaviorSubject<SpaceContext | null>(null);
  public activeContext$ = this.activeContextSubject.asObservable();

  constructor() {}

  async loadContexts() {
    try {
      const contexts = await this.api.query<SpaceContext[]>('GET_MY_CONTEXTS').toPromise();
      
      if (contexts && contexts.length > 0) {
        this.availableContextsSubject.next(contexts);
        
        // Auto-select the first workspace/context if none is currently selected
        if (!this.activeContextSubject.value) {
          // Prefers workspaces or anything not an org if possible, otherwise first one
          const defaultContext = contexts.find(c => c.type === 'WORKSPACE') || contexts[0];
          this.setActiveContext(defaultContext);
        }
      }
    } catch (error) {
      console.error('Failed to load user contexts', error);
    }
  }

  setActiveContext(context: SpaceContext) {
    this.activeContextSubject.next(context);
  }

  setActiveContextById(id: string) {
    const contexts = this.availableContextsSubject.value;
    const context = contexts.find(c => c.id === id);
    if (context) {
      this.setActiveContext(context);
    }
  }

  getActiveContextId(): string | undefined {
    return this.activeContextSubject.value?.id;
  }
}
